class Feedback {
	constructor() {
		this.selectors = {
			document: document,
			feedbackForm: '#feedback_form',
			feedbackFormMobile: '#feedback_form_mobile',
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
		$(document).ready(()=>{
			function successFeedback(thisForm, confirmBlock) {
				thisForm[0].reset();
				$(confirmBlock).addClass('active');
				setTimeout(() => {
					$(confirmBlock).removeClass('active');
				}, 3000);
			};
			function errorFeedback(errorBlock, errors) {
				if (errors){
					$(errorBlock).text(errors).addClass('active');
				} else{
					$(errorBlock).addClass('active');
				}
				setTimeout( ()=>{
					$(errorBlock).removeClass('active')
				},3000)
			};
			// Feedback Form
			if ($('#js-feedback-btn').hasClass('g-recaptcha')) {				
				const recaptchaKey = $('#js-feedback-btn').data('sitekey');
				grecaptcha.ready(() => {
					grecaptcha.execute(`${recaptchaKey}`, {action: 'submit'})				
				});
				window.afterInvisActivated = function(){
					const $this = $('#feedback_form'),
						data  = $this.serialize();									
					$.post($this.attr('action'), data, function(resp){						
						resp.success ? successFeedback($this, '#feedback_confirmation') : grecaptcha.reset();
					});
				}
			} else {
				this.nodes.feedbackForm.on('submit', function(e){
					e.preventDefault();
					var $this = $(e.currentTarget);
					$.post($this.attr('action'),$this.serialize(),function(resp){						
						resp.success ? successFeedback($this, '#feedback_confirmation') : errorFeedback('#feedback_error', resp.errors);
					});
				});
			}

			// Feedback Form Mobile
			if ($('#js-feedback-mobile-btn').hasClass('g-recaptcha')) {				
				const recaptchaKeyMobile = $('#js-feedback-mobile-btn').data('sitekey');
				grecaptcha.ready(() => {
					grecaptcha.execute(`${recaptchaKeyMobile}`, {action: 'submit'})				
				});
				window.afterInvisActivatedMobile = function(){
					const $this = $('#feedback_form_mobile'),
						data  = $this.serialize();									
					$.post($this.attr('action'), data, function(resp){						
						resp.success ? successFeedback($this, '#feedback_confirmation_mobile') : grecaptcha.reset();
					});
				}
			} else {
				this.nodes.feedbackFormMobile.on('submit', function(e){
					e.preventDefault();
					var $this = $(e.currentTarget);
					$.post($this.attr('action'),$this.serialize(),function(resp){
						resp.success ? 
						successFeedback($this, '#feedback_confirmation_mobile') : errorFeedback('#feedback_error_mobile', resp.errors);
					});

				});
			}
		});
	}
}
new Feedback();
